import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { create, type StateCreator } from 'zustand';
interface ChatState {
  isBjLive: boolean;
  toggleIsBjLive: () => void;
  resetIsBjLive: () => void;
}
const store: StateCreator<ChatState, [], [], ChatState> = set => ({
  isBjLive: false,
  toggleIsBjLive: () => set(state => ({
    isBjLive: !state.isBjLive
  })),
  resetIsBjLive: () => set({
    isBjLive: false
  })
});
const usePickBjLiveToggleStore = create(store);
export const usePickBjLiveToggle = () => {
  const $ = _c(7);
  const isBjLive = usePickBjLiveToggleStore(_temp);
  const toggleIsBjLive = usePickBjLiveToggleStore(_temp2);
  const resetIsBjLive = usePickBjLiveToggleStore(_temp3);
  let t0;
  let t1;
  if ($[0] !== resetIsBjLive) {
    t0 = () => () => {
      resetIsBjLive();
    };
    t1 = [resetIsBjLive];
    $[0] = resetIsBjLive;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== isBjLive || $[4] !== resetIsBjLive || $[5] !== toggleIsBjLive) {
    t2 = {
      isBjLive,
      toggleIsBjLive,
      resetIsBjLive
    };
    $[3] = isBjLive;
    $[4] = resetIsBjLive;
    $[5] = toggleIsBjLive;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default usePickBjLiveToggleStore;
function _temp(state) {
  return state.isBjLive;
}
function _temp2(state_0) {
  return state_0.toggleIsBjLive;
}
function _temp3(state_1) {
  return state_1.resetIsBjLive;
}